import { makeStyles } from '../../../../../../styles';
export default makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        border: `1px solid ${theme.colors.gray[200]}`,
        borderRadius: theme.spacing(1),
        flex: 1,
        height: 435,
    },
    header: {
        background: theme.colors.gray[0],
        display: 'flex',
        padding: theme.spacing(2),
        alignItems: 'center',
        borderBottom: `1px solid ${theme.colors.gray[200]}`,
    },
    content: {
        padding: theme.spacing(0),
        height: '100%',
        display: 'flex',
        paddingBottom: '0!important',
    },
    eventsWrapper: {
        flex: '1 0 48%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
    },
    eventsFilter: {
        padding: theme.spacing(1),
        borderRight: `1px solid ${theme.colors.gray[200]}`,
    },
    events: {
        padding: theme.spacing(0, 1, 1),
        borderRight: `1px solid ${theme.colors.gray[200]}`,
        overflowY: 'auto',
        height: '245px',
        position: 'relative',
        overflow: 'hidden',
    },
    title: {
        fontSize: '12px',
        color: theme.colors.gray['700'],
        fontWeight: 600,
        textTransform: 'uppercase',
    },
    titleShadow: {
        position: 'absolute',
        transition: 'all 0.1s ease-in-out',
        width: '100%',
        background: 'linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0) 100%)',
        height: '30px',
        zIndex: '2',
        opacity: '0',
        pointerEvents: 'none',
    },
    titleShadowShow: {
        opacity: 1,
    },
    customMetricsButton: {
        position: 'relative',
        bottom: '0',
        display: 'block',
        padding: theme.spacing(1),
        borderTop: `1px solid ${theme.colors.gray[200]}`,
        borderRight: `1px solid ${theme.colors.gray[200]}`,
    },
    metrics: {
        flex: '1 0 48%',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        maxHeight: '450px',
        overflowY: 'auto',
    },
}));
//# sourceMappingURL=EventSelectorCard.styles.js.map